<template>
  <div>
    <template v-if="isLoadedNormal">
      <p class="mb-2">
        Levels amount in main sequence: {{levelInfo.levelsAmount}}
      </p>
      <p class="mb-2">
        Upcoming level number: {{upcomingLevelNumber}}<br>
        Upcoming level does not exist.
        It is a level that will be added.<br>
        You can use upcoming level number to set player level.<br>
        It means that player passed all levels, and new level (that will be added) will be available for player.
      </p>
      <form @submit.prevent="save">
        <div class="form-group">
          <label for="level">Level</label>

          <!--
            Иногда инсайдер забывают обновить.
            Поэтому в инсайдере иногда нет последних уровней.
            В этом случае при редактировании уровня игрока через инсайдер нет возможности установить требуемый уровень.
            По просьбе тех поддержки отключил проверку.
            Теперь, даже если инсайдер не обновлен, они могут установить игроку нужный уровень.
            Правильность ввода не проверяется автоматически.
            Можно установить несуществующий уровень.
            :max="upcomingLevelNumber"
          -->
          <input v-model="newLevelValue" id="level" class="form-control level-input" type="number" min="1" required v-focus>
        </div>

        <b-button :to="{name: 'player_info'}">Cancel</b-button>
        <b-button type="submit" variant="primary">Save</b-button>
      </form>
    </template>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';
import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'PlayerLevelEdit',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      levelInfo: null,
      newLevelValue: null,
      isSaving: false,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    upcomingLevelNumber() {
      return this.levelInfo.levelsAmount + 1;
    },
  },

  created() {
    this.loadLevelInfo();
  },

  methods: {
    loadLevelInfo() {
      notifier.deleteSenderNotifications(this);
      this.loadState = LOAD_STATE_LOADING;

      const url = `/player/${this.playerId}/level_info`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.levelInfo = data;
        this.newLevelValue = data.level;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e, {sender: this});
      });
    },

    save() {
      if(this.isSaving) {
        return;
      }
      this.isSaving = true;

      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.append('level', this.newLevelValue);

      const url = `/player/${this.playerId}/level`;
      HTTP.post(url, data)
      .then(() => {
        this.isSaving = false;
        notifier.showSuccessAfterTransition('Level changed.');
        this.$router.push({name: 'player_info'});
      })
      .catch(e => {
        this.isSaving = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>

<style scoped>
.level-input {
  max-width: 300px;
}
</style>
